export const RUBRIC_ROUTES = {
    CREATE: '/rubric',
    GET_ALL: '/rubric',
    GET_BY_ID: (id: string) => `/rubric/${id}`,
    UPDATE: (id: string) => `/rubric/${id}`,
    DELETE: (id: string) => `/rubric/${id}`,
} as const;
